import React, { useMemo } from "react";
import { Select } from "antd";
import moment from "moment";
import { getPresetDateRange } from "./chartUtils";

const { Option } = Select;

const PresetRangeSelector = ({
  value,
  onChange,
  placeholder = "Preset Range",
  style = { width: 280 },
  allowClear = true,
  disabled = false,
  presetOptions = [
    { value: "last3Days", label: "Last 3 Days" },
    { value: "lastWeek", label: "Last Week" },
    { value: "lastMonth", label: "Last Month" },
    { value: "lastQuarter", label: "Last Quarter" }
  ]
}) => {
  const enhancedOptions = useMemo(() => {
    return presetOptions.map(option => {
      const dateRange = getPresetDateRange(option.value);
      if (dateRange) {
        const start = dateRange.start;
        const end = dateRange.end;
        const currentYear = moment().year();
        
        let dateLabel = '';
        
        if (option.value === 'last3Days') {
          dateLabel = `(${start.format('MMM D')} - ${end.format('MMM D')})`;
        } else if (option.value === 'lastWeek') {
          dateLabel = `(${start.format('MMM D')} - ${end.format('MMM D')})`;
        } else if (option.value === 'lastMonth') {
          const monthYear = start.year() === currentYear ? 
            start.format('MMMM') : start.format('MMMM YYYY');
          dateLabel = `(${monthYear})`;
        } else if (option.value === 'lastQuarter') {
          if (start.year() === currentYear && end.year() === currentYear) {
            dateLabel = `(${start.format('MMM D')} - ${end.format('MMM D')})`;
          } else {
            dateLabel = `(${start.format('MMM D')} - ${end.format('MMM D, YYYY')})`;
          }
        }
        
        return {
          ...option,
          enhancedLabel: `${option.label} ${dateLabel}`
        };
      }
      return option;
    });
  }, []); 

  return (
    <Select
      value={value}
      onChange={onChange}
      style={style}
      placeholder={placeholder}
      allowClear={allowClear}
      disabled={disabled}
    >
      {enhancedOptions.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.enhancedLabel || option.label}
        </Option>
      ))}
    </Select>
  );
};

export default PresetRangeSelector;
